import * as React from 'react';
import c from 'classnames';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { DynamicMediaItem, TargetAudienceCard } from '../../../../components';
import { TaxonomyTargetAudience } from '../../../../types/uncinc_profile/taxonomy';

interface TargetAudienceProps {
  entity: ImmutableEntity<TaxonomyTargetAudience>;
  aboveTheFold?: Boolean;
  className?: string;
}

const TaxonomyTargetAudienceTeaser: React.FC<TargetAudienceProps> = ({
  entity,
  aboveTheFold = false,
  className,
}) => {
  const classes = c('TaxonomyTargetAudienceTeaser', className);
  const targetAudience = entity.toJS();

  const language = targetAudience.langcode[0].value;
  const path = targetAudience.paths[language];
  const name = targetAudience.name[0].value;
  const description = targetAudience.field_description_with_summary[0]?.summary;
  const media = targetAudience.field_media_item[0];

  return (
    <TargetAudienceCard
      className={classes}
      type="secondary"
      title={name}
      subtitle={description ?? undefined}
      link={path}
      // These cards are only designed for supporting SVGs. If the given media is not of this type,
      // return undefined. This will internally result in a fallback SVG.
      image={media.bundle === 'svg' && (
        <DynamicMediaItem
          media={media}
          aboveTheFold={aboveTheFold}
        />
      )}
    />
  );
};

export default TaxonomyTargetAudienceTeaser;
